module.exports = {"350128100":"潭城镇","350128101":"苏澳镇","350128102":"流水镇","350128103":"澳前镇","350128104":"北厝镇","350128105":"平原镇","350128106":"敖东镇","350128200":"白青乡","350128201":"屿头乡","350128202":"大练乡","350128203":"芦洋乡","350128204":"中楼乡","350128205":"东庠乡","350128206":"岚城乡","350128207":"南海乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350128.json
// module id = 1172
// module chunks = 0